import { DefaultTheme } from './defaultTheme';

export const theme: DefaultTheme = {
  color: {
    primary: '#FFFFFF',
    secondary: 'rgba(255, 255, 255, 0.5)'
  },
  background: {
    primary: '#1c313e',
    secondary: '#324956'
  },
  utility: {
    accent: '#48DDB4',
    highlight: '#DD48B4'
  },
  spacing: {
    tiny: 4,
    small: 8,
    medium: 16,
    large: 24,
  },
  fontSize: {
    small: 12,
    medium: 14,
    larger: 16,
    large: 24,
  }
};
